export const sports = [
    { id: '4', name: 'cricket' },
    { id: '1', name: 'soccer' },
    { id: '2', name: 'tennis' },
    { id: '6', name: 'casino' }
]

export const filter = [
    { value: 'All', label: 'All' },
    { value: 'Cricket', label: 'Cricket' },
    { value: 'Soccer', label: 'Soccer' },
    { value: 'Tennis', label: 'Tennis' },
    { value: 'casino', label: 'Casino' }
]

export const Games = {
    DRAGON_TIGER: 'Dragon Tiger',
    T20_TEEN_PATTI: 'T20 Teen Patti'
}

export const CasinoURLS = {
    DRAGON_TIGER: '/casino/?game_name=dragontiger',
    T20_TEEN_PATTI: '/casino/?game_name=t20teenpatti'
}

export const users = [
  { type: "Seniorsuper", usertype: "2" },
  { type: "Supermaster", usertype: "3" },
  { type: "Master", usertype: "4" },
  { type: "Client", usertype: "5" },
];